import { render } from "./FilterAreaByGroupRole.vue?vue&type=template&id=0859b961"
import script from "./FilterAreaByGroupRole.vue?vue&type=script&lang=js"
export * from "./FilterAreaByGroupRole.vue?vue&type=script&lang=js"
script.render = render

export default script